export const BASE_API_URL =
  process.env.REACT_APP_BASE_API_URL || 'https://swapi.dev/api';
